export function formatDate(iso) {
  if (!iso) return "—";
  try {
    const s = String(iso).trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
      const [y, m, d] = s.split('-').map(Number);
      const date = new Date(y, m - 1, d);
      if (Number.isNaN(date.getTime())) return s;
      return date.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
    }
    const fixed = s.replace(/(\.\d{3})\d+(Z?)$/, "$1$2");
    const d = new Date(fixed);
    if (Number.isNaN(d.getTime())) return s;
    return d.toLocaleString();
  } catch {
    return String(iso);
  }
}

export function formatTimeAgo(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return '';
  const now = new Date();
  const diffMs = now - date;
  // If timestamp is in the future (clock skew), show 'just now'
  if (diffMs < 0) return 'just now';
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);
  if (diffMins < 1) return 'just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  return `${diffDays}d ago`;
}
